module.exports = __webpack_public_path__ + "static/media/MuhammadSaqib.cd5cbcd6.jpeg";